import React from 'react'
import { FadeIn } from 'lib/ui/components'
import { OrderHistory } from '../../components/OrderHistory'

export const Orders = () => {
  return (
    <FadeIn>
      <OrderHistory />
    </FadeIn>
  )
}
